import script from "./SButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SButton.vue?vue&type=script&setup=true&lang=js"

import "./SButton.vue?vue&type=style&index=0&id=ab7d1e5c&scoped=true&lang=scss"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab7d1e5c"]])

export default __exports__